
import apiProxy from './api-proxy-inst';

class AuthApi {
  signIn(args) {
    return apiProxy.requestPublic('/administrator_authentication/do', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  changePassword(args) {
    return apiProxy.request('/cur_administrator_password/change', args).then(data => {
      if (data.succeeded) {}
      return data;
    });
  }

  renew() {
    return apiProxy.request('/authentication/renew').then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }
}

export default new AuthApi();
